import { Button } from '@components/styled/Button.styled';
import { Label } from '@components/styled/Label.styled';
import { Colors } from '@src/colors';
import styled, { css } from 'styled-components';
import { fontBodySm, fontButtonDefault } from '../../typography.styled';

export const SubmitGroup = styled.div`
    display: flex;
    gap: 25px;
    margin-top: auto;
    margin-bottom: auto;

    > ${Button} {
        height: 48px;
    }

    ${Label} {
        ${fontButtonDefault}
        color: ${Colors.vacasaBlue}
    }
`;

export const SpinnerWrapper = styled.div`
    width: 109.19px;
    height: 48px;
    display: flex;
    justify-content: center;

    > svg {
        margin: auto;
        height: 45px;
        width: 45px;
    }
`;

export const Info = styled.div`
    width: 236px;
    height: 42px;

    ${fontBodySm}
    text-align: left;

    visibility: visible;
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    animation: fadeIn 1s;
`;

export const SuccessCard = styled.div<{ visible: boolean }>`
    display: flex;

    width: 246px;
    height: 48px;

    padding: 8px 13px;
    gap: 10px;

    background: #f0f5ec;
    border: 1px solid #6ba342;

    span {
        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: left;
    }

    ${(props) =>
        props.visible
            ? css`
                  visibility: visible;
                  @keyframes fadeIn {
                      0% {
                          opacity: 0;
                      }
                      100% {
                          opacity: 1;
                      }
                  }
                  animation: fadeIn 1s;
              `
            : css`
                  visibility: hidden;
                  opacity: 0;
                  transition:
                      visibility 0s 1s,
                      opacity 1s linear;
              `}
`;
